<template>
  <div class="">
    <Breadcrumb :title="$t('miga.RGPD')" />
    <DatosIntroducidos />

    <div class="whitebox row">
      <h1 class="text-center my-4">{{ $t('rgpd.title') }}</h1>
        {{ $t('rgpd.body') }}

<dl class="row my-5">
    <hr/>

  <dt class="col-sm-3">{{ $t('rgpd.codigo') }}</dt>
  <dd class="col-sm-9"><strong>{{ fichaRGPD.codigo }}</strong></dd>
  <hr/>

  <dt class="col-sm-3">{{ $t('rgpd.hnombre') }}</dt>
  <dd class="col-sm-9"><strong>{{ fichaRGPD.nombre }}</strong></dd>
  <hr/>

  <dt class="col-sm-3">{{ $t('rgpd.hresponsable') }}</dt>
  <dd class="col-sm-9">Universidad del País Vasco / Euskal Herriko Unibertsitatea</dd>
  <hr/>

  <dt class="col-sm-3">{{ $t('rgpd.hfinalidad') }}</dt>
  <dd class="col-sm-9">{{ fichaRGPD.finalidad }}</dd>
  <hr/>

  <dt class="col-sm-3">{{ $t('rgpd.hlegitimacion') }}</dt>
  <dd class="col-sm-9">{{ fichaRGPD.legitimacion }}</dd>
  <hr/>

  <dt class="col-sm-3">{{ $t('rgpd.hderechos') }}</dt>
  <dd class="col-sm-9">{{ fichaRGPD.derechos }}</dd>
  <hr/>

  <dt class="col-sm-3">{{ $t('rgpd.hinfoadicional') }}</dt>
  <dd class="col-sm-9" v-html="fichaRGPD.infoadicional"></dd>
  <hr/>

</dl>


      <table class="table my-5 d-none">
        <thead class="thead-dark">
          <tr>
            <th scope="col">{{ $t('rgpd.codigo') }}</th>
            <th scope="col">{{ fichaRGPD.codigo }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="col">{{ $t('rgpd.hnombre') }}</th>
            <th scope="col">{{ fichaRGPD.nombre }}</th>
          </tr>
          <tr>
            <th scope="col">{{ $t('rgpd.hresponsable') }}</th>
            <td>Universidad del País Vasco / Euskal Herriko Unibertsitatea</td>
          </tr>
          <tr>
            <th scope="col">{{ $t('rgpd.hfinalidad') }}</th>
            <td>{{ fichaRGPD.finalidad }}</td>
          </tr>
          <tr>
            <th scope="col">{{ $t('rgpd.hlegitimacion') }}</th>
            <td>{{ fichaRGPD.legitimacion }}</td>
          </tr>
          <tr>
            <th scope="col">{{ $t('rgpd.hderechos') }}</th>
            <td>{{ fichaRGPD.derechos }}</td>
          </tr>
          <tr>
            <th scope="col">{{ $t('rgpd.hinfoadicional') }}</th>
            <td v-html="fichaRGPD.infoadicional" />
          </tr>
        </tbody>
      </table>
      <div class="form-group">
        <div class="float-right">
          <input
            class="form-check-input mx-2"
            id="conforme"
            type="checkbox"
            v-model="conforme"
            tabindex="1"
          />
          <label
            class="form-check-label ml-4"
            style="display: unset"
            for="conforme"
          >
            {{ $t("conforme") }}
          </label>
        </div>
      </div>
    </div>

    <NavButton
      anterior="SelectChannel"
      siguiente="PersonalData"
      :siguienteIf="conforme"
    />
  </div>
</template>
<script>
import Vue from 'vue';
import Breadcrumb from "@/components/Breadcrumb";
import DatosIntroducidos from "../components/DatosIntroducidos";
import NavButton from "../components/NavButton";

import Session from "@/session/Session.js";

export default {
  name: "SelectService",
  components: {
    Breadcrumb,
    DatosIntroducidos,
    NavButton,
  },
  data: () => ({
    conforme: null,
    fichaRGPD: {}
  }),
  beforeDestroy() {
    window.removeEventListener("language.changed", this.init);
  },

  async mounted() {
    window.addEventListener("language.changed", () => { this.init(); Vue.nextTick(this.init); window.vueinstance.$forceUpdate(); });
    this.init();
  },

  methods: {
    async init() {
      let cfg = Session.getConfiguration()
      window.console.log('cgf', cfg)
      let q = cfg.rgpd[ Session.getQueue().id] || cfg.rgpd[ '*' ]
      let lan = Session.getLanguage() || {}
      this.fichaRGPD = q[lan.locale] || {}
    },
    onSelect(s) {
      Session.setServicePoint(s);
      window.console.log("onServicePointSelect>", s);
      this.$router.push({ name: 'SelectChannel' });
    },
  },
};
</script>

<style scoped>
</style>
